import React, {useEffect, useState} from 'react';
import { useParams } from 'react-router-dom';
import {useScreenDetector} from "../../hooks/useScreenDetector.ts";
import {Order} from "../../types/Order.interface.ts";
import {DesktopOrderPage} from "./pages/DesktopOrderPage/DesktopOrderPage.tsx";
import {MobileOrderPage} from "./pages/MobileOrderPage/MobileOrderPage.tsx";
import {PaymentType} from "../../types/PaymentMethod.ts";
import Preloader from '../../ui/Loader/Preloader.tsx';
import { API_URL } from '../../config.tsx';


interface Props {
}


export const OrderPage: React.FC<Props> = () => {
    const { hash } = useParams<{ hash: string }>();
    const { isDesktop} = useScreenDetector();
    const [orderOffer, setOrderOffer] = useState<Order|null>(null);
    const [paymentMethod, setPaymentMethod] = useState<string>(PaymentType.sbp);
    const [isLoading, setIsLoading] = useState<boolean>(false);

    const getOrderOffer = (hash: string) => {
        fetch(`${API_URL}/order_offer?hash=${hash}`, {
            method: 'GET',
            credentials: 'include',
        })
            .then(response => response.json())
            .then(data => setOrderOffer(data))
            .finally(() => setIsLoading(false));
    }

    const onPaymentMethodChange = (variant: string) => {
        setPaymentMethod(variant);
    };

    const getPaymentUrl = (orderId: number) => {
        fetch(`${API_URL}/order/${orderId}/payment_url?paymentMethod=${paymentMethod}`, {
            method: 'GET',
            credentials: 'include',
        })
            .then(response => response.json())
            .then(data => {
                if(data.url) document.location = data.url;
            })
    }

    useEffect(() => {
        if(hash) {
            setIsLoading(true);
            getOrderOffer(hash);
        }
    }, [hash]);

    if(isLoading) return <Preloader />;
    if(!orderOffer) return null;

    return (<>
        {
            isDesktop
                ? <DesktopOrderPage
                    orderOffer={orderOffer}
                    onPaymentMethodChange={onPaymentMethodChange}
                    getPaymentUrl={getPaymentUrl}
                    paymentMethod={paymentMethod}
                />
                : <MobileOrderPage
                    orderOffer={orderOffer}
                    onPaymentMethodChange={onPaymentMethodChange}
                    getPaymentUrl={getPaymentUrl}
                    paymentMethod={paymentMethod}
                />
        }
    </>);
};
